import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { PracticeReportState } from './redux';

export const reportPracticeSelector = (state: RootState) => state.practiceReport;
export const paramsSelector = createSelector(reportPracticeSelector, (state: PracticeReportState) => state.params);
export const itemViewSelector = createSelector(reportPracticeSelector, (state: PracticeReportState) => state.itemView);
export const listLicenseSelector = createSelector(reportPracticeSelector, (state: PracticeReportState) => state.listLicense);